import Immutable from 'immutable';
import AppConstants from '../constants/AppConstants';
import ErrorConstants from '../constants/ErrorConstants';

const initialState = Immutable.Map({
  currentLocale: null,
  featureFlags:  Immutable.Map(),
  messages:      Immutable.List(),
  appVersion:       null,
  allowFeatureFlagEditing: false,
  baseUrl:       '/v2',
  coreAssets: Immutable.Map(),
  internalError: Immutable.Map(),
  localBranch: null,
  mobileApp: false
});

export default function app(state = initialState, action) {
  switch (action.type) {
    case AppConstants.LOAD_APP_CONFIG: {
      return state.merge(action.appConfig);
    }

    case AppConstants.UPDATE_FEATURE_FLAG_SUCCESS: {
      return state.setIn(['featureFlags', action.payload.flag], action.payload.enabled);
    }

    case ErrorConstants.STORE_INTERNAL_ERROR: {
      return state.setIn(['internalError'], Immutable.fromJS(action.payload.error));
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/AppReducer.js